import { SupervisorAccount } from '@mui/icons-material'
import { TeamManagementPanel } from './TeamManagementPanel'
import { useAdventureEditorStore } from '../../../stores/adventureEditorStore'

export function ModeratorPanel() {
  const adventureId = useAdventureEditorStore((state) => state.adventureId)

  return (
    <TeamManagementPanel
      adventureId={adventureId}
      roleType="Moderator"
      title="Adventure Moderators"
      description="Moderators can moderate content and user participation"
      icon={<SupervisorAccount />}
    />
  )
}
